import React from 'react'
import DescriptionInput from 'ui-shared/WrappedInputs/DescriptionInput'
import ProductSectionForm, {
  ProductSectionFormProps,
} from './ProductSectionForm'
import VirtualExpSpecialTypeInput from 'ui-shared/CustomInputs/VirtualExpSpecialTypeInput'

type Props = Omit<ProductSectionFormProps, 'entity'> & {
  entity: Extract<
    ProductSectionFormProps['entity'],
    'foods' | 'virtuals' | 'physicals'
  >
}

const OptionedProductSectionForm: React.FC<Props> = (props) => {
  return (
    <ProductSectionForm {...props}>
      <DescriptionInput />
      {props.entity === 'virtuals' && <VirtualExpSpecialTypeInput />}
    </ProductSectionForm>
  )
}

export default OptionedProductSectionForm
